var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FwfImportConfig_1;
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ImportOperation } from '../importTask';
import { FlatFileImportConfig } from './flatFileImportConfig';
import { ImportConfigType } from './importConfig';
import './fwfColumnConfiguration';
import './dataPreprocessConfig';
import { fwfImportConfigSchemaValidation } from '../../validations.generated';
export const fwfImportConfigSchema = {
    $id: 'urn:wisepipe-common-data:FwfImportConfig',
    type: 'object',
    properties: {
        hasHeader: { type: 'boolean' },
        delimiter: { type: 'string', minLength: 1, maxLength: 1 },
        columnConfiguration: { $ref: 'urn:wisepipe-common-data:FwfColumnConfiguration' },
        dataPreprocessConfig: { $ref: 'urn:wisepipe-common-data:DataPreprocessConfig' }
    },
    required: ['hasHeader']
};
let FwfImportConfig = FwfImportConfig_1 = class FwfImportConfig extends FlatFileImportConfig {
    constructor(s3File, hasHeader, delimiter, columnConfiguration, dataPreprocessConfig, columnsToUpdate) {
        super(ImportConfigType.Fwf, s3File, columnsToUpdate);
        this.hasHeader = hasHeader;
        this.delimiter = delimiter;
        this.columnConfiguration = columnConfiguration;
        this.dataPreprocessConfig = dataPreprocessConfig;
        JSON.validate(this, FwfImportConfig_1);
    }
    get supportedRefreshOperations() {
        return [ImportOperation.Overwrite];
    }
    get needsDiscovery() {
        return true;
    }
    get shouldTargetCleanData() {
        return true;
    }
    get fileTypeSupportsTargetParquet() {
        return true;
    }
    get fileTypeSupportsDataPreprocess() {
        return true;
    }
    get isFileTypeCsv() {
        return false;
    }
    static cleanTableName(filename) {
        // Keep the safe characters as described here: https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html, change all others to a dash
        return filename.replace(/[^a-z0-9\/!\-_\.*'\(\) ]/gi, '-');
    }
};
FwfImportConfig = FwfImportConfig_1 = __decorate([
    JsonSchemaV2(fwfImportConfigSchema, fwfImportConfigSchemaValidation),
    JsonDiscriminatorValue(ImportConfigType.Fwf)
], FwfImportConfig);
export { FwfImportConfig };
//# sourceMappingURL=fwfImportConfig.js.map